module.exports = __webpack_public_path__ + "img/ai_data.1144570c.jpg";